// gatewayMetaMap.ts
export interface GatewayMeta {
    currency: string;
    bgColor: string;
    imgSrc: string;
  }
  
  export const gatewayMetaMap: Record<string, GatewayMeta> = {
    PawaPay: {
      currency: "MWK",
      bgColor: "#B48BC2",
      imgSrc: "/images/gateways/pawapay.png",
    },
    PayPal: {
      currency: "USD",
      bgColor: "#CDE6F8",
      imgSrc: "/images/gateways/paypal.png",
    },
    Stripe: {
      currency: "USD",
      bgColor: "#B276FF",
      imgSrc: "/images/gateways/stripe.png",
    },
    TNM: {
      currency: "MWK",
      bgColor: "#4188C1",
      imgSrc: "/images/gateways/tnm.png",
    },
  };
  